import translator from '@/locales';

import SearchTermInstallPriceColumn from './SearchTermInstallPriceColumn';
import AverageInstallCostColumn from '@@/advertisement/common/keyword/columns/AverageInstallCostColumn';
import ConversionRateColumn from '@@/advertisement/common/keyword/columns/ConversionRateColumn';
import ImpressionColumn from '@@/advertisement/common/keyword/columns/ImpressionColumn';
import InstallColumn from '@@/advertisement/common/keyword/columns/InstallColumn';
import MatchTypeColumn from '@@/advertisement/common/keyword/columns/MatchTypeColumn';
import QueryColumn from '@@/advertisement/common/keyword/columns/QueryColumn';

import { sum, average } from '@/utils/arrayAggregation';

export default {
  static: [
    {
      label: translator.t('ADVERTISEMENT.SEARCH_TERMS.SEARCH_TERM_COLUMN'),
      property: 'query',
      component: QueryColumn,
      summaryBehaviour: () => translator.t('SUM'),
      fixed: true,
    },
  ],
  dynamic: [
    {
      label: translator.t('ADVERTISEMENT.BID.KEYWORD'),
      property: 'bidQuery',
      component: QueryColumn,
    },
    {
      label: translator.t('ADVERTISEMENT.BID.MATCH_TYPE'),
      property: 'matchingType',
      component: MatchTypeColumn,
      fixed: false,
      readOnly: true,
    },
    {
      label: translator.t('ADVERTISEMENT.BID.COLUMN_AVG_CPI'),
      property: 'avgInstallCost',
      component: AverageInstallCostColumn,
      isHiddenDefault: false,
      width: 180,
    },
    {
      label: translator.t('ADVERTISEMENT.BID.COLUMN_CONV_RATE'),
      property: 'conversionRate',
      component: ConversionRateColumn,
      isHiddenDefault: false,
      summaryBehaviour: vals => '%' + average(vals),
    },

    {
      label: translator.t('ADVERTISEMENT.BID.COLUMN_IMPRESSIONS'),
      property: 'impressionCount',
      component: ImpressionColumn,
      isHiddenDefault: false,
      summaryBehaviour: sum,
    },
    {
      label: translator.t('ADVERTISEMENT.BID.COLUMN_INSTALLATION'),
      property: 'installCount',
      component: InstallColumn,
      isHiddenDefault: false,
      summaryBehaviour: sum,
      width: 180,
    },
    {
      label: 'Install Price',
      property: 'installPrice',
      component: SearchTermInstallPriceColumn,
      isHiddenDefault: false,
    },
  ],
};
